import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

@Injectable()
export class MatPaginatorIntlBr extends MatPaginatorIntl {
    itemsPerPageLabel = 'Itens por página';
    nextPageLabel = 'Próximo';
    previousPageLabel = 'Anterior';

    getRangeLabel = function (page, pageSize, length) {
        if (length === 0 || pageSize === 0) {
            return 'Nenhum resultado';
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        return `${startIndex + 1} a ${endIndex} de ${length} resultados`;
    };
}
